/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getAttributionDashboardV1QuerySchema = z.object({
  period: z.enum(['7d', '30d', 'all']).default('7d'),
});

export type IGetAttributionDashboardV1Query = z.input<typeof getAttributionDashboardV1QuerySchema>;
